/* global window */

import { RouteHandler } from 'wee-routes';
import $events from 'wee-events';

export default new RouteHandler({
    init() {
        $events.on('a', 'click', (e) => {
            const loc = e.target.href;
            // eslint-disable-next-line no-useless-escape
            const offsite = RegExp('^(\/[a-z0-9]|tel:|https?:\/\/[^/]*\.ascendfcu\.org|https:\/\/img\.storage\.ascend\.org|https:\/\/cs\.loanspq\.com\/consumer\/v2\/login\/landing\.aspx|https:\/\/oac\.fmsiportal\.com|https:\/\/secure\.ascend\.org|' + window.siteUrl.replace('/', '\\/') + ')');

            if (typeof loc !== 'undefined' && loc.length && ! offsite.test(loc)) {
                // eslint-disable-next-line no-alert
                if (! window.confirm(window.offsiteText)) {
                    e.preventDefault();
                }
            }
        });
    },
});
